import { Client } from "../../clients/client";

import { PaginationForm, Pagination } from "@/common/mixins/pagination";
import { Permission } from "./models/Permission";

export class PermissionUseCase {
  constructor(private permission: Client) {}

  public async getPermissions(
    form: PaginationForm
  ): Promise<Pagination<Permission>> {
    return this.permission.permissions.getPermissions({
      page: form && form.page,
      limit: form && form.perPage
    });
  }
}
